import {useState} from 'react'
import {useParams} from 'react-router-dom'
import {KTSVG} from '../../../../../template/helpers/components/KTSVG'
import {crmAPI} from '../../../../../services/CRMService'
import {AccessToken1CModal} from '../../modals/AccessToken1CModal'
import clsx from 'clsx'
import {useIntl} from 'react-intl'

const AccessToken1C = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const [getToken1C] = crmAPI.useLazyGetToken1CQuery()
  const [buffer, setBuffer] = useState(false)
  const [show, setShow] = useState(false)
  const [token, setToken] = useState<string>('')

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const clipboard = () => {
    setBuffer(true)
    getToken1C(appId!)
      .unwrap()
      .then((response) => {
        navigator.permissions.query({name: 'clipboard-write' as PermissionName}).then((result) => {
          if (result.state === 'granted' || result.state === 'prompt') {
            navigator.clipboard.writeText(response)
          } else if (result.state === 'denied') {
            if (response) {
              setToken(response)
              handleShow()
            }
          }
        })
        setTimeout(() => {
          setBuffer(false)
        }, 600)
      })
  }

  return (
    <div className='row mb-5'>
      <label className='col-lg-4 fw-bolder text-gray-600 text-uppercase small'>
        {intl.formatMessage({id: 'APPS.1C.TOKEN'})}
      </label>
      <div className='col-lg-8 d-flex justify-content-between align-items-center'>
        <div className={clsx('badge', {'badge-light-info': !buffer}, {'badge-light-success': buffer})}>
          eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2...
        </div>
        <button
          onClick={clipboard}
          className={clsx('btn btn-link pt-0 pb-0', {'text-hover-primary': !buffer}, {'text-hover-success': buffer})}
        >
          {!buffer ? (
            <KTSVG path='/media/icons/duotune/general/gen054.svg' className='svg-icon-gray-900' />
          ) : (
            <KTSVG path='/media/icons/duotune/arrows/arr012.svg' className='svg-icon-success' />
          )}
        </button>
      </div>
      <AccessToken1CModal accessToken={token} show={show} handleClose={handleClose} />
    </div>
  )
}

export {AccessToken1C}
